import { render, staticRenderFns } from "./NormativaFormulario.vue?vue&type=template&id=2a621a36&scoped=true"
import script from "./NormativaFormulario.vue?vue&type=script&lang=js"
export * from "./NormativaFormulario.vue?vue&type=script&lang=js"
import style0 from "./NormativaFormulario.vue?vue&type=style&index=0&id=2a621a36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a621a36",
  null
  
)

export default component.exports